var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C8.465 2 8.6975 2 8.88825 2.05111C9.40585 2.18981 9.8102 2.59413 9.9489 3.11177C10 3.30252 10 3.53501 10 4V8.6C10 9.4401 10 9.8601 9.8365 10.181C9.6927 10.4632 9.46325 10.6927 9.181 10.8365C8.8601 11 8.4401 11 7.6 11H4.4C3.55992 11 3.13988 11 2.81902 10.8365C2.53677 10.6927 2.3073 10.4632 2.16349 10.181C2 9.8601 2 9.4401 2 8.6V4C2 3.53501 2 3.30252 2.05111 3.11177C2.18981 2.59413 2.59413 2.18981 3.11177 2.05111C3.30252 2 3.53501 2 4 2M4.8 3H7.2C7.48005 3 7.62005 3 7.727 2.9455C7.8211 2.89756 7.89755 2.82107 7.9455 2.72699C8 2.62004 8 2.48003 8 2.2V1.8C8 1.51997 8 1.37996 7.9455 1.27301C7.89755 1.17893 7.8211 1.10243 7.727 1.05449C7.62005 1 7.48005 1 7.2 1H4.8C4.51998 1 4.37996 1 4.27301 1.05449C4.17893 1.10243 4.10243 1.17893 4.05449 1.27301C4 1.37996 4 1.51997 4 1.8V2.2C4 2.48003 4 2.62004 4.05449 2.72699C4.10243 2.82107 4.17893 2.89756 4.27301 2.9455C4.37996 3 4.51998 3 4.8 3Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBordIcon);
export default __webpack_public_path__ + "static/media/bord_icon.fcce7cf13e6b197612f54116882bb1ba.svg";
export { ForwardRef as ReactComponent };